import { render, staticRenderFns } from "./AccountResetCredentials.vue?vue&type=template&id=57fa1b62"
import script from "./AccountResetCredentials.vue?vue&type=script&lang=js"
export * from "./AccountResetCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports